import React from 'react';
/*
here we are rendering the child of scroll which is CardList
and in style 1->{} shows javascript expression ,2nd->jsx
*/
const Scroll = (props) => {
    return(
        <div style={{overflow:'scroll',border:'5px solid black',height:'800px'}}>
            {props.children}
        </div>
       
    );
   
};
export default Scroll;